module.exports = __webpack_public_path__ + "static/media/14.1318a4f1.jpg";